<template>
  <footer class="related-posts" v-if="Object.entries(relatedPosts).length > 0">
    <h3>Related Posts</h3>
    <div class="related-posts__grid">
      <BlogItem class="blog-item" v-for="post in relatedPosts" :key="post.id" :post="post"/>
    </div>
  </footer>
</template>

<script>
import BlogItem from '../../components/Blog/BlogItem.vue';

export default {

  data() {
    return {
      doublet: {}
    }
  },

  computed: {
    relatedPosts() {
      return this.$store.state.relatedPosts;
    }
  },

  components: {
    BlogItem
  },

  beforeMount() {
    this.doublet = {};
  },

  mounted() {
    this.getRelatedPosts();
  },

  methods: {
    getRelatedPosts() {
      
      const related_per_page = this.$wpoptions.related_per_page;
      
      this.$store.dispatch('getRelatedPosts', { post: this.$parent.post.id, per_page: related_per_page }).then(res => {
  
        let parentPost = this.$parent.post;

          var filteredData = res.data.filter(post => {

            if (post.cat_name[0].name === parentPost.cat_name[0].name) {       

              // Check to see if there is a doublet, and store the doublet in a variable
              if (post.id === parentPost.id && res.data.length > 0) {
                this.doublet = post;
              }

            return true;
            }

            return false;

          })

          this.$store.commit('setRelatedPosts', filteredData);

          // If a doublet is found, filter again.
          if (this.doublet.id === parentPost.id) {

            let postsArray = Object.values(this.$store.state.relatedPosts);

            postsArray = postsArray.filter(post => post.id !== parentPost.id);

            this.$store.commit('setRelatedPosts', postsArray);

          }
        

      })

    }

  },

  watch: {
    '$route' (to, from) {
      this.getRelatedPosts();
    }
  }
  
}


</script>

<style lang="scss" scoped>

</style>